import axios from "@/plugins/axios";

window.trackEvent = async (eventName, props) => {
  const data = {
    eventName: eventName,
    properties: props,
  };
  return axios.post("/api/rest/trackEvent", data).catch((err) => console.error(err));
};
